export default __webpack_public_path__ + "images/13_2_image.jpg";